import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { calculateTotalPrice, getToken } from "../../resources/helper/helper";
import { createOrder } from "../../redux/features/orderSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/features/cartSlice";
import { CircularProgress } from "@mui/material";
import { WidthFull } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PaymentForm = ({ credentials, cart, selectedPayment }) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getToken();
  const [loading, setLoading] = useState(false);

  const getProductIds = () => {
    const ids = cart.map((item) => item._id);
    return ids;
  };

  const getProductInfo = () => {
    const productInfo = cart.map((item) => ({
      productId: item?._id,
      vendorId: item?.vendor?._id,
      quantity: item?.quantity,
    }));
    return productInfo;
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    // Step 1: Create a payment intent on the backend
    const response = await axios.post(`${API_BASE_URL}/payment-intent`, {
      amount: 50, // Adjust amount to the total of your order
    });

    // Extract clientSecret from response
    const clientSecret = response.data.clientSecret;

    if (!clientSecret) {
      console.error("Failed to retrieve client secret from backend.");
      return;
    }

    // Step 2: Confirm the card payment using the clientSecret from the backend
    const { error, paymentIntent } = await stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      }
    );

    if (error) {
      console.error("Payment Error:", error.message);
      toast.error(error.message, {
        position: "top-center",
        theme: "colored",
      });
      setLoading(false);
      return;
    }

    if (paymentIntent && paymentIntent.status === "succeeded") {
      if (token) {
        const payload = {
          token,
          orderData: {
            productIds: getProductIds(),
            address: credentials.address,
            firstName: credentials?.firstName,
            lastName: credentials?.lastName,
            email: credentials?.email,
            phone: credentials?.phoneNumber,
            info: credentials?.additionalInfo,
            total: calculateTotalPrice(cart),
            paymentType: selectedPayment,
            productInfo: getProductInfo(),
          },
        };
        dispatch(createOrder(payload))
          .unwrap()
          .then(() => {
            toast.success("Order Created successfully!", {
              position: "top-center",
              theme: "colored",
            });
            const data = {
              products: cart,
              address: credentials.address,
              firstName: credentials?.firstName,
              lastName: credentials?.lastName,
              email: credentials?.email,
              phone: credentials?.phoneNumber,
              total: calculateTotalPrice(cart),
              paymentType: selectedPayment,
            };
            navigate("/invoice", { state: data });
            dispatch(clearCart());
            setLoading(false);
          })
          .catch((err) => {
            toast.error(err, {
              position: "top-center",
              theme: "colored",
            });
            setLoading(false);
          });
      }
    }
  };

  return (
    <form style={formStyle} onSubmit={handleSubmit}>
      <div style={inputContainerStyle}>
        <CardElement options={cardElementOptions} />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button
          className="btn btn-fill-out btn-block w-50 mt-20"
          type="submit"
          style={buttonStyle}
          disabled={!stripe}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Place an Order"
          )}
          {!loading && <i className="fi-rs-sign-out ml-15" />}
        </button>
      </div>
    </form>
  );
};

// Inline CSS styles
const formStyle = {
  Width: "100%",
  alignItems: "center",
  background: "#ffffff",
  padding: "20px",
  margin: "20px auto",
};

const inputContainerStyle = {
  marginBottom: "20px",
};

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      fontFamily: "'Roboto', sans-serif",
      "::placeholder": {
        color: "#aab7c4",
      },
      padding: "10px 12px",
    },
    invalid: {
      color: "#fa755a",
    },
  },
};

const buttonStyle = {
  color: "#fff",
  padding: "10px 20px",
  borderRadius: "5px",
  fontSize: "16px",
  border: "none",
  cursor: "pointer",
};

export default PaymentForm;
